import Script from 'next/script'
import React, { type FC } from 'react'
import useBasePath from '../hooks/useBasePath'

interface Props {
  activate: boolean
  onLoad: () => void
}

const ThreatMetrixScript: FC<Props> = ({ onLoad, activate }) => {
  const withBasePath = useBasePath()

  if (!activate) {
    return null
  }

  return (
    <Script
      data-testid="threatmetrix-script"
      src={withBasePath('/threatmetrix-fp-clientlib-v6_0.js')}
      strategy="afterInteractive"
      onLoad={onLoad}
    />
  )
}

export default ThreatMetrixScript
